// extracted by mini-css-extract-plugin
module.exports = {"blinking":"customOption_blinking__2PpcC","blinkOption":"customOption_blinkOption__2IO3j"};